/**
 * Queue Store Module
 */

import path from 'path'
import Vue from 'vue'
import { firebaseMutations, firebaseAction } from 'vuexfire'
import fb from '@/lib/fb'
import { app } from '@/../config/app.json'

// Types
import * as types from '@/lib/store/types'

// Constants
const refs = new fb.refs(app.showId)

// State
const state = {
	queue: []
}

const actions = {
	[types.ADD_QUEUE] ({commit}, data)
	{
		let queuePath = path.join(refs.queue)
		let queueRef = fb.database().ref(queuePath)
		let newRef = queueRef.push()
		let newKey = newRef.key

		return new Promise( (resolve, reject) => {
			newRef.set( fb.prepIn(data), res => {
				resolve(newKey)
			})
		})
	},

	[types.LOAD_QUEUE]: firebaseAction( ({commit, bindFirebaseRef}, key) => {
		const queuePath = path.join(refs.queue)
		const queueRef = fb.database().ref(queuePath)
		return new Promise( (resolve, reject) => {
			bindFirebaseRef('queue', queueRef, {readyCallback: () => {
				resolve()
			}})
		})
	}),
}

const mutations = {
	[types.SET_QUEUE] (state, data)
	{
		let res = []
	}
}

const getters = {
	queue: state => state.queue
}

export default {
	state,
	actions,
	mutations,
	getters
}


// WEBPACK FOOTER //
// ./src/lib/store/modules/Queue.js